import { createBrowserHistory } from 'history';
const hist = createBrowserHistory();

export default hist;
